import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { productFields, productField } from './common/productFields';
import { msg } from '@lingui/core/macro';

export const soldProductCircularityMetadata = {
  displayName: msg({
    message: 'Sold products: Durability',
    context: 'Activity data schema name for sold product circularity',
  }),
  fields: {
    ...coreFields,
    ...productFields,
    durability: {
      displayName: msg({
        message: 'Product durability',
        context: 'The display name for a dimension',
      }),
    },
    industry_average_durability: {
      displayName: msg({
        message: 'Product durability industry average',
        context: 'The display name for a dimension',
      }),
    },
    product_name: productField,
    repairability: {
      displayName: msg({
        message: 'Product repairability',
        context: 'The display name for a dimension',
      }),
    },
    repairability_rating_system: {
      displayName: msg({
        message: 'Product repairability rating system',
        context: 'The display name for a dimension',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
